module.exports = __webpack_public_path__ + "img/doc-sub.de4e86dd.svg";